/** DF4's product.cshtml emits the redesign arm (q4_2026_product_page_3, product.cshtml.cs InitSIG) as __AB_Product_Page. */
declare var __AB_Product_Page: boolean | undefined;

/** True when this page renders the step-by-step product page ("B"). Absent (old DF4, the image generator) is the control. */
export function isProductPageRedesign(): boolean {
    return typeof __AB_Product_Page !== 'undefined' && __AB_Product_Page === true;
}
